<!-- Loading bar -->
<fuse-loading-bar></fuse-loading-bar>

<!-- Navigation -->
<fuse-vertical-navigation
    #vertical="fuseVerticalNavigation"
    class="dark bg-gray-900 print:hidden"
    [appearance]="navigationAppearance"
    [mode]="isScreenSmall ? 'over' : 'side'"
    [name]="'mainNavigation'"
    [navigation]="navigation.default"
    [opened]="!isScreenSmall">
    <!-- Navigation header hook -->
    <ng-container fuseVerticalNavigationContentHeader>
        <div class="flex items-center pb-0 mt-2">
            <div class="text-secondary logo-container h-full w-full flex justify-center px-4">
                <img [class.hidden]="!vertical._hovered && vertical.appearance !== 'default'"
                    class="w-3/4 max-w-3/4 min-w-3/4"
                    src="assets/images/logo/logo-text-on-dark.png"
                />
                <img
                    [class.hidden]="vertical._hovered || vertical.appearance === 'default'"
                    src="assets/images/logo/logo-min.png"
                />
            </div>
        </div>
    </ng-container>
</fuse-vertical-navigation>

<!-- Wrapper -->
<div class="flex flex-col flex-auto w-full min-w-0">

    <!-- Header -->
    <div class="relative flex flex-0 items-center w-full h-16 px-4 md:px-6 z-49 shadow dark:shadow-none dark:border-b bg-card dark:bg-transparent print:hidden">
        <div class="flex items-center pr-2 space-x-2">
            <!-- Navigation toggle button -->
            <button
                mat-icon-button
                (click)="toggleNavigation('mainNavigation')">
                <mat-icon [svgIcon]="'heroicons_outline:menu'"></mat-icon>
            </button>
            <!-- Navigation appearance toggle button -->
            <button
                class="hidden md:inline-flex"
                mat-icon-button
                (click)="toggleNavigationAppearance()">
                @if(navigationAppearance === 'default') {
                    <mat-icon [svgIcon]="'mat_outline:keep_off'"></mat-icon>
                } @else {
                    <mat-icon [svgIcon]="'mat_outline:keep'"></mat-icon>
                }
            </button>
        </div>
        <!-- Components -->
        <div class="flex items-center pl-2 ml-auto space-x-0.5 sm:space-x-2">
            <fuse-fullscreen class="hidden md:block"></fuse-fullscreen>
            @if(!isVisitant()) {
                <notifications></notifications>
            }
            <user></user>
        </div>
    </div>

    <!-- Content -->
    <div class="flex flex-col flex-auto">
        <!-- *ngIf="true" hack is required here for router-outlet to work correctly.
             Otherwise, layout changes won't be registered and the view won't be updated! -->
        <router-outlet *ngIf="true"></router-outlet>
    </div>

    <!-- Footer -->
    <div class="relative overflow-hidden md:flex items-center justify-center w-full h-35 px-4 py-4 md:px-6 z-49 border-t bg-card dark:bg-transparent print:hidden">
        <span class="font-medium text-secondary flex items-center justify-center">{{ 'general.footer.copyright' | transloco }}</span>
    </div>
</div>
